<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <h1 class="mb-4">Hello, Sitefinity Partner!</h1>
                <p class="mb-8">Welcome to WebStack in TCVelik!</p>
                
                <div class="w-full max-w-md mx-auto">
                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full mb-4" />
                  <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

                  <div class="flex items-center mt-6 mb-6">
                    <vs-checkbox v-model="isTermsConditionAccepted" class="mr-2" />
                    <span>
                      I accept the 
                      <a href="https://www.tcvelik.com/privacy.html" target="_blank" style="color: var(--primary) !important;" class="underline" @click.stop>privacy policy</a>
                    </span>
                  </div>

                  <vs-button 
                    class="w-full sm:w-auto" 
                    @click="registerUser" 
                    :disabled="!validateForm">
                    Send Magic Link
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import AccountsService from '@/accounts/accountsService'

export default {
  data() {
    return {
      email: '',
      isTermsConditionAccepted: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    registerUser() {
      if (!this.validateForm) return

      const payload = {
        userDetails: {
          email: this.email,
          returnUrl: this.$route.query.return || '/pages/home',
          campaignName: 'SitefinityPRT2005'
        }
      }

      AccountsService.createAccount(payload)
        .then(response => {
          if (response.Success) {
            this.$vs.notify({
              title: 'Success',
              text: 'Please check your email for the magic link.',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            // Get the return URL from localStorage
            const returnUrl = localStorage.getItem('returnUrl');
          } else {
            this.$vs.notify({
              title: 'Error',
              text: response.message || 'Something went wrong!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message || 'Something went wrong!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script> 
